import {DefaultResType, ErrorType} from "../../types/common/response";
import {baseApi} from "../../util/axiosConfig";
import {AnalyzeSearchParamType} from "../../pages/inventory/analyze/list/interface";
import {AnalyzeFormulaUpdateElementType} from "../../pages/inventory/analyze/formula/interface";

const url = "api/inventory/sub_function/";

export async function readInventoryAnalysis(param: AnalyzeSearchParamType): Promise<DefaultResType> {
    try {
        return await baseApi.post(url + "read_inventory_analysis", param);
    } catch (err: any) {
        return err?.response;
    }
}

export async function exportInventoryAnalysisExcel(param: AnalyzeSearchParamType): Promise<Blob | ArrayBuffer | Uint8Array | string | ErrorType> {
    const response = await baseApi.post(url + "export_inventory_analysis_excel", param, {
        responseType: "blob",
    });

    return response?.data;
}

export async function readFormula(): Promise<DefaultResType> {
    try {
        return await baseApi.post(url + "read_formula");
    } catch (err: any) {
        return err?.response;
    }
}

export async function updateFormula(data: AnalyzeFormulaUpdateElementType[]): Promise<DefaultResType> {
    try {
        return await baseApi.post(url + "update_formula", data);
    } catch (err: any) {
        return err?.response;
    }
}